import Switch from '@ingka/switch';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { localeService } from '../../services';
import { AppDispatch, RootState } from 'src/store';
import { setCoverOnly } from '../../store/cover';
import { CoverItem, TranslationsKey } from 'sofa-reborn-react';

export const CoverOnlySwitch = () => {
	const dispatch = useDispatch<AppDispatch>();
	const selectedCover = useSelector<RootState, CoverItem | null>(
		(state) => state.cover.selectedCover
	);
	const coverOnly = useSelector<RootState, boolean | undefined>((state) => state.cover.coverOnly);
	const handleOnChange = useCallback(() => {
		dispatch(setCoverOnly(!coverOnly));
	}, [dispatch, coverOnly]);

	const disabled = !selectedCover?.isRemovable;
	const translationKey: TranslationsKey = disabled
		? 'coverOnlyDisabledLabel'
		: 'coverOnlyDisclaimerTitle';

	return (
		<Switch
			id="cover-only"
			label={localeService.getTranslation(translationKey)}
			disabled={disabled}
			value={(coverOnly ?? 'false').toString()}
			checked={coverOnly}
			onChange={handleOnChange}
			onKeyDown={(e) => {
				if (e.key === 'Enter') {
					handleOnChange();
				}
			}}
		/>
	);
};
